import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import BlockUi from 'react-block-ui';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import './parcelas-donut-card.css';

const EMPTY_RING = [{ key: 'empty', value: 1 }];

const percentOf = (value, total) => (total > 0 ? Math.round((value / total) * 100) : 0);

const ParcelasDonutCard = ({ title, total, totalLabel, items, blocking = false, onSegmentClick }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <div className="prc-card">
      <BlockUi tag="div" message="" blocking={blocking} renderChildren={true}>
        <h6 className="prc-card-title">{title}</h6>
        <div className="prc-card-body">
          <div className="prc-donut">
            <ResponsiveContainer width="100%" aspect={1}>
              <PieChart margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
                {total > 0 ? (
                  <Pie
                    data={items}
                    dataKey="value"
                    startAngle={90}
                    endAngle={-270}
                    innerRadius="62%"
                    outerRadius="100%"
                    stroke="#fff"
                    strokeWidth={2}
                    // hover re-renders the Pie; with animation on, Recharts recreates the sectors and the click is lost
                    isAnimationActive={false}
                    onMouseEnter={(_, index) => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}>
                    {items.map((item, index) => (
                      <Cell
                        key={item.key}
                        fill={item.color}
                        fillOpacity={hoveredIndex === null || hoveredIndex === index ? 1 : 0.45}
                        cursor={onSegmentClick ? 'pointer' : 'default'}
                        onClick={() => onSegmentClick && onSegmentClick(item.key)}
                      />
                    ))}
                  </Pie>
                ) : (
                  <Pie data={EMPTY_RING} dataKey="value" innerRadius="62%" outerRadius="100%" stroke="none" isAnimationActive={false}>
                    <Cell fill="#ECECEA" />
                  </Pie>
                )}
              </PieChart>
            </ResponsiveContainer>
            <div className="prc-donut-center">
              <span className="prc-donut-total">{total.toLocaleString('en-US')}</span>
              <span className="prc-donut-caption">{totalLabel}</span>
            </div>
          </div>
          {/* div + roles instead of ul/li: the global theme styles bare lists (flex, margins) and overflows the card on mobile */}
          <div className="prc-legend" role="list">
            {items.map((item, index) => {
              const isEmpty = item.value === 0;
              return (
                <div
                  key={item.key}
                  role="listitem"
                  className={`prc-legend-row${hoveredIndex === index ? ' is-hovered' : ''}`}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}>
                  <span className="prc-legend-dot" style={{ backgroundColor: item.color }} />
                  {item.to && !isEmpty ? (
                    <Link className="prc-legend-label prc-legend-link" to={item.to}>
                      {item.label}
                    </Link>
                  ) : (
                    <span className={`prc-legend-label${isEmpty ? ' is-empty' : ''}`}>{item.label}</span>
                  )}
                  <span className={`prc-legend-value${isEmpty ? ' is-empty' : ''}`}>{item.value.toLocaleString('en-US')}</span>
                  <span className="prc-legend-percent">{percentOf(item.value, total)}%</span>
                </div>
              );
            })}
          </div>
        </div>
      </BlockUi>
    </div>
  );
};

export default ParcelasDonutCard;
